import React from "react";
import "./CircleProgressBar.scss"

const cleanPercentage = (percentage) => {
  const tooLow = !Number.isFinite(+percentage) || percentage < 0;
  const tooHigh = percentage > 100;
  return tooLow ? 0 : tooHigh ? 100 : +percentage;
};

const Circle = ({ colour, pct, r, number, width, height }) => {
  const circ = 2 * Math.PI * r;
  const strokePct = number ? 100 : ((100 - pct) * circ) / 100;
  return (
    <circle
      r={r}
      cx="50%"
      cy="50%"
      fill="transparent"
      stroke={strokePct !== circ ? colour : ""} // remove colour as 0% sets full circumference
      strokeWidth={"0.5rem"}
      strokeDasharray={circ}
      strokeDashoffset={pct && !number ? strokePct : 0}
      strokeLinecap="round"
    ></circle>
  );
};

const Text = ({ percentage, number }) => {
  return (
    <text
      x="50%"
      y="50%"
      dominantBaseline="central"
      textAnchor="middle"
      fontSize={"1em"}
      fontWeight={"bold"}
      cursor={"pointer"}
    >
      {number ? percentage : percentage.toFixed(2) + '%'}
    </text>
  );
};

const CircleProgressBar = ({ percentage, colour, width, height, radius, onClickAction, number=false }) => {
  const pct = number? percentage : cleanPercentage(percentage);
  return (
    <div className="circle-progress-bar" style={{width: width, height: height}} onClick={onClickAction}>
      <svg width={width} height={height}>
        <g transform={`rotate(-90 ${"50 50"})`}>
          <Circle colour="lightgrey" r={radius} width={width} height={height}/>
          <Circle colour={colour} pct={pct} r={radius} width={width} height={height} number={number}/>
        </g>
        <Text percentage={pct} number={number} />
      </svg>
    </div>
  );
};

export default CircleProgressBar;
